// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_4r-7";
export var adjustableWidthBorderHeld = "_4r-8";
export var arrow = "_4r-3";
export var arrowButton = "_4r-4";
export var headerCell = "_4r-0";
export var help = "_4r-2";
export var icon = "_4r-1";
export var iconWrapper = "_4r-6";
export var noBorder = "_4r-b";
export var nonAdjustableWidthBorder = "_4r-9";
export var nonAdjustableWidthBorderHeld = "_4r-a";
export var textButton = "_4r-5";